import React from 'react';
import { useBusinessSubscription } from '../../hooks/useBusinessSubscription';
import UpgradeCTA from './UpgradeCTA';

/**
 * Gates content based on business subscription feature access (supplier)
 * @param {String|Array} feature - Feature key(s) required
 * @param {ReactNode} fallback - Custom fallback when locked
 * @param {Boolean} requireAll - If true, requires all features (AND)
 * @param {String} reason - Custom reason for upgrade CTA
 * @param {ReactNode} children - Content when access granted
 */
const SupplierFeatureGate = ({
  feature,
  fallback = null,
  requireAll = false,
  reason,
  children,
  showUpgradePrompt = true
}) => {
  const { hasFeature, hasAnyFeature, hasAllFeatures, loading } = useBusinessSubscription();

  if (loading) {
    return null;
  }

  let hasAccess = false;
  if (Array.isArray(feature)) {
    hasAccess = requireAll ? hasAllFeatures(feature) : hasAnyFeature(feature);
  } else {
    hasAccess = hasFeature(feature);
  }

  if (hasAccess) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  if (showUpgradePrompt) {
    return <UpgradeCTA reason={reason || feature} compact />;
  }

  return null;
};

export default SupplierFeatureGate;
